// Third party libraries
import { formatISO, parseISO, format, fromUnixTime, addDays } from 'date-fns'; 
import { zonedTimeToUtc, utcToZonedTime } from 'date-fns-tz';

export const dateMixins = {
	data() {
		return {
			displayFormat: 'DD-MMM-YYYY'
		}
	},
	computed: {
		userTimezone() {
			return this.$store.getters.getUserDetails.defaultTimezone;
		},
		petBirthDate() {
			return this.$store.getters.getActivePet.birthdate;
		}
	},
	methods: {
		disabledNextYear(date) {
			return date > new Date(new Date().setFullYear(new Date().getFullYear(), 12, 0)) || date < parseISO(this.petBirthDate);
		},
		notBeforePetBirthdate(date) {
			return date > parseISO(this.petBirthDate);
		},
		petBirthDateUntilToday(date) {
			return date > new Date() || date < parseISO(this.petBirthDate);
		},
		dateToISO(date) {
			if (!date) {
				return date;
			}

			// convert date to String to prevent replace is not a function errors
			return formatISO(new Date(date.toString().replace(/-/g, ' ')), { representation: 'date' });
		},
		dateToUtc(date) {
			if (!date) {
				return date;
			}

			return format(new Date(date), "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'");
		},
		formatDatetoDisplay(date) {
			if (!date) {
				return date;
			}

			return parseISO(date);
		},
		formatDate(date, dateFormat = 'dd-MMM-yyyy') {
			if (!date) {
				return date;
			}

			if (typeof date === 'string') {
				date = new Date(parseISO(date));
			}

			if (typeof date === 'number') {
				date = fromUnixTime(date);
			}

			return this.utcConvertToZonedTime(date, dateFormat);
		},
		formatDateWithoutConversion(date, dateFormat = 'dd-MMM-yyyy') {
			if (!date) {
				return date;
			}

			if (typeof date === 'string') {
				date = new Date(parseISO(date));
			}

			if (typeof date === 'number') {
				date = fromUnixTime(date);
			}

			return format(date, dateFormat);
		},
		formatDateTime(date, dateFormat = 'dd-MMM-yyyy hh:mm a') {
			if (!date) {
				return date;
			}

			if (typeof date === 'string') {
				date = new Date(parseISO(date));
			}

			if (typeof date === 'number') {
				date = fromUnixTime(date);
			}

			return this.utcConvertToZonedTime(date, dateFormat);
		},

		formatDateTimeWithoutConversion(date, dateFormat = 'dd-MMM-yyyy hh:mm a') {
			if (!date) {
				return date;
			}

			if (typeof date === 'string') {
				date = new Date(parseISO(date));
			}

			if (typeof date === 'number') {
				date = fromUnixTime(date);
			}

			return format(date, dateFormat);
		},
		pastDates(date) {
			let today = new Date();
			today.setDate(today.getDate() - 1);
			return date < today;
		},
		localizedDate(date) {
			const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
			date = zonedTimeToUtc(date, timeZone);
			return date;
		},
		addDaysToDate(date, amount) {
			if (typeof date === 'string') {
				date = new Date(parseISO(date));
			}

			if (typeof date === 'number') {
				date = fromUnixTime(date);
			}

			return this.formatDate(addDays(date, amount));
		},
		utcConvertToZonedTime(date, dateFormat, isUTC) {
			// Get User's Default Timezone
			const utcDate = !isUTC ? this.dateToUtc(date) : date;
			const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
			const setFormat = dateFormat ? dateFormat : 'dd-MMM-yyyy';
			const convertedDate = utcToZonedTime(utcDate, timeZone);
			const formattedDate = format(convertedDate, setFormat);
			return formattedDate;
		}
	}
}